import React, { useState, useEffect, useRef, useMemo } from "react";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios, { axiosLatest } from "../../axios";
import Loader from "../../Shared Components/loader";
import {
  PAYPAL_CLIENT_ID,
  AUTH_TOKEN,
  BACKEND_URL,
  SALE_ACTIVE,
} from "../../urls";
import ModalViewComponent from "../Shared Components/modalView";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";
import { sendRequestToLogging } from "../../ErrorBoundary";
import {
  LineSkeleton,
  LineSkeletonLg,
} from "../../Skeletons/skeletonTemplates";
import Shimmer from "../../Skeletons/shimmer";
import { Button, Icon, Image } from "semantic-ui-react";
import $ from "jquery";
import { fetchBrowserInfo } from "../utils";
import AddOnServices from "./addOnServices";
import AddOnTimer from "./addOnTimer";
import { useSelector, shallowEqual } from "react-redux";
import PaymentsFailureModal from "./paymentModals/paymentFailureModal";
import PhonePePaymentComponent from "./phonePePayment";
import {
  ERROR_MESSAGE,
  ADDONS_ACTIONS,
  ADDONS_TYPES,
  redirectURLForFailure,
} from "../constants";
import "../stylesheets/paymentsPageStyles.css";
import {
  PREMIUM_PAGE_URL,
  THREE_NINETY_PAYMENTS_URL,
  WINTER_CARNIVAL_URL,
} from "../../constants";
import IbmAddOnService from "./ibmAddOnService";
import OfferLabel from "./offerLabel";
import { profileImages } from "./constants";

const scrollToQrCard = () => {
  if (window.innerWidth <= 768) {
    const ele = document.querySelector(".appDownloadQr");
    ele.scrollIntoView({ block: "end", behavior: "smooth" });
  }
};

// is used to show different course name for specified batches
const BATCH_SLUG_COURSE_NAME_MAPPING = {
  "front-end-1": "Front End Mastery",
};

function OrderSummaryComponent(props) {
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [premiumDiscount, setPremiumDiscount] = useState("");
  const [finalPrice, setFinalPrice] = useState(0);
  const [coursePrice, setCoursePrice] = useState(0);
  const [coursePromotionalPrice, setCoursePromotionalPrice] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCouponCode, setAppliedCouponCode] = useState("");
  const [couponErrorMessage, setCouponErrorMessage] = useState("");
  const [couponError, setCouponError] = useState(false);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isCouponButtonPressed, setIsCouponButtonPressed] = useState(false);
  const [transactionToken, setTransactionToken] = useState("");
  const [title, setTitle] = useState("");
  const [gateway, setGateway] = useState("");
  const [doubtSupportPrice, setdoubtSupportPrice] = useState(0);
  const [courseId, setCourseID] = useState("");
  const [isOpenPaypal, setIsOpenPaypal] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);
  const [isPaymentConfirmButtonClicked, setIsPaymentConfirmButtonClicked] =
    useState(false);
  const [paymentConfirmtitle, setPaymentConfirmTitle] = useState("");
  const [message, setMessage] = useState("");
  const [extra, setExtra] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [successFlag, setSuccessFlag] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const [showPaymentLoader, setShowPaymentLoader] = useState(false);
  const [showVerificationLoader, setShowVerificationLoader] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showCouponIp, setShowCouponIp] = useState(false);
  const [addOnServices, setAddOnServices] = useState(undefined);
  const [addOnSavings, setAddOnSavings] = useState(0);
  const [currentTime, setCurrentTime] = useState(null);
  const [isAutoApplyCouponApiCalled, setIsAutoApplyCouponApiCalled] =
    useState(false);
  const [showPaymentFailureModal, setShowPaymentFailureModal] = useState(false);
  const [androidPaymentQRLink, setAndroidPaymentQRLink] = useState(null);

  const [isIbmAddOnAdded, setIsIbmAddOnAdded] = useState(false);
  const [isIbmAddOnButtonLoading, setIsIbmAddOnButtonLoading] = useState(false);

  const [showQrSection, setShowQrSection] = useState(false);

  toast.configure();
  const notify = () =>
    toast("Reloading the page in 3 seconds!!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
    });
  const toastRef = useRef(null);
  // keep all items/slugs in lower case
  const couponNotApplicableCourses = [
    "knowledge-booster-session",
    "winter-interview-prep-course-2",
    "gsc2023-ticket-7500",
    "gsc2023-ticket-4000",
    "gate-rank-booster"
  ];
  // const discountModalCoursesSlug = ['complete-test-series-product-companies','Java-Programming-basic-to-advanced','cpp-programming-basic-to-advanced','c-Programming-basic-to-advanced','dpa-self-paced','CS-12']
  const discountModalCoursesSlug = [];
  const { userData } = useSelector((state) => {
    const { userData } = state;
    return { userData };
  }, shallowEqual);

  useEffect(() => {
    if (props.location.state) window.history.replaceState(null, "");
    // If the URL is for payments, don't call payment/fetch API
    if (!isTransactionForPhonePe()) loadData();
  }, []);

  useEffect(() => {
    if (
      discountModalCoursesSlug.includes(props.courseSlug) &&
      coursePromotionalPrice &&
      coursePrice
    )
      $("#discountModal").modal("show");
  }, [coursePromotionalPrice, coursePrice, discountModalCoursesSlug]);

  const addOnhasDsHelper = () =>
    addOnServices?.findIndex(
      (el) => el?.service_info?.service_type === "doubt assistance"
    );

  useEffect(() => {
    if (!addOnServices) return;

    const params = new URLSearchParams(props.location.search);
    let couponValue =
      params.get("coupon") ||
      props.coupon ||
      addOnServices?.find(
        (addOn) =>
          addOn?.service_info?.service_type === "coupon" &&
          currentTime <= new Date(addOn?.end_time)
      )?.service_info?.coupon_code;

    if (
      transactionToken &&
      couponValue &&
      !couponNotApplicableCourses.includes(props.courseSlug.toLowerCase()) &&
      !isAutoApplyCouponApiCalled
    ) {
      couponValue = couponValue.toUpperCase();
      setCouponCode(couponValue);
      applyCoupon(couponValue);
      setShowCouponIp(true);
    }
  }, [
    transactionToken,
    addOnServices,
    isAutoApplyCouponApiCalled,
    props?.isDoubtSupportAdded,
  ]);

  function isTransactionForPhonePe() {
    const currentPageUrl = window.location.href;
    return (
      currentPageUrl.includes("/payments") &&
      currentPageUrl.includes("type=verify")
    );
  }

  function createAndSendErrorObject(msg) {
    const errorObj = {
      msg,
      userDetails: userData,
      browserDetails: fetchBrowserInfo(),
      pageUrl: window.location.href,
    };
    sendRequestToLogging(JSON.stringify({ traceback: errorObj }));
  }

  async function loadRazorPay(gateway) {
    if (gateway === "razorpay") {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        const msg = "Failed to load Razorpay SDK. Are you online?";
        alert(msg);
        createAndSendErrorObject(msg);
        return;
      }
    }
  }
  useEffect(() => {
    const delayInPaymentInitiated = 7; // Change it as per requirement
    if (sessionStorage.getItem("initiatePayment")) {
      window.paymentInitiatedTimer = setTimeout(
        () => crmPaymentInitiated(),
        delayInPaymentInitiated * 1000
      );
    }

    return () => {
      clearTimeout(window.paymentInitiatedTimer);
    };
  }, []);

  useEffect(() => {
    if (transactionToken) {
      if (
        props?.data?.hasIbmCertification &&
        props?.data?.ibmCertificationDetails &&
        sessionStorage.getItem(`ibm_cert_${props?.courseSlug}`)
      ) {
        addRemoveAddOns({
          action: ADDONS_ACTIONS.ADD_TO_CART,
          type: ADDONS_TYPES.EXTERNAL_CERTIFICATION,
        });
      }
    }
  }, [transactionToken]);

  async function crmPaymentInitiated() {
    await axios
      .put(`crm/course-page/payment-initiate/?clicked_on_pay_fee=true`, {
        product_id: props.courseId,
        batch_id: props.batchId,
        page_url: window.location.href,
        http_referer: document.referrer,
        product_type: 1,
      })
      .then((res) => {
        sessionStorage.removeItem("initiatePayment");
      })
      .catch((err) => {
        console.log(err.response);
      });
  }

  async function loadData() {
    await axiosLatest

      .get(
        `/payment/fetch/?pslug=${props.data.batchSlug}&ptype=101&course_slug=${props?.courseSlug}`
      )
      .then((res) => {
        let currentTime = res?.headers?.["x-date"];
        currentTime = currentTime ? new Date(currentTime) : new Date();
        setCurrentTime(currentTime.getTime());
        setCoursePromotionalPrice(
          res.data.results.promotional_fee || res.data.results.batch_fee
        );
        setCoursePrice(res.data.results.final_fee);
        setAndroidPaymentQRLink(res.data.results.payment_deep_link_android);
        setPremiumDiscount(
          res.data.results.premium_discount
            ? res.data.results.premium_discount
            : 0
        );
        setAddOnServices(res.data.results["add_ons"] || []);
        setFinalPrice(res.data.results.final_fee);
        setTransactionToken(res.data.results.transaction_token);
        setGateway(res.data.results.gateway);
        loadRazorPay(res.data.results.gateway);
        setTitle(res.data.results.title);
        setCourseID(res.data.results.courseId);
        setPremiumDiscount(
          res.data.results.premium_discount === null
            ? "0"
            : res.data.results.premium_discount
        );
        setIsLoaded(true);
        props.addOnsHandler(res?.data?.results?.["add_ons"] || []);
        if (
          props.data.has_doubt_assistance &&
          props.data.doubt_assistance_fee === 0
        )
          props.toggleDoubtSupport(true);
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        alert(ERROR_MESSAGE);
      });
    setdoubtSupportPrice(props.data.doubt_assistance_fee);
  }

  async function applyCoupon(coupon) {
    setIsCouponButtonPressed(true);
    setIsAutoApplyCouponApiCalled(true);

    await axios
      .get(
        `/coupon/apply-coupon/?coupon_code=${coupon}&transaction_token=${transactionToken}`
      )
      .then((res) => {
        setIsCouponApplied(true);
        setCouponDiscount(res.data.results.discount);
        setFinalPrice(res.data.results.payable_amount);
        setAppliedCouponCode(coupon);
        setCoursePrice(res.data.results.product_price);
        setCouponError(false);
      })
      .catch((error) => {
        // if (androidPaymentQRLink) {
        //     setShowPaymentFailureModal(true);
        // } else {

        if (
          error?.response?.data?.error?.code === 406 &&
          error?.response?.data?.error?.message
        )
          setCouponErrorMessage(error.response.data.error.message);
        else setCouponErrorMessage("Invalid Coupon");
        setCouponError(true);
        // }
      })
      .finally(() => {
        setIsCouponButtonPressed(false);
      });
  }

  async function removeCoupon() {
    await axios
      .post("/payment/addtocart/remove/", {
        type: "coupon",
        transaction_token: transactionToken,
        course_id: courseId,
      })
      .then((res) => {
        setFinalPrice(res.data.payable_amount);
        setIsCouponApplied(false);
        setCoursePrice(res.data.product_price);
        setCouponDiscount(0);
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        alert(ERROR_MESSAGE);
      });
  }

  function handleCouponApply() {
    if (!couponCode) return;
    setCouponErrorMessage("");
    applyCoupon(couponCode);
  }

  function handleCouponRemove() {
    removeCoupon();
  }

  async function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  function successfullPurchaseEvent() {
    try {
      window?.dataLayer?.push({
        event: "successful-purchase",
        purchase_value: finalPrice,
        transaction_id: transactionToken,
        enhanced_conversion_data: {
          email: props?.data?.userEmail,
          phone_number: `${props?.data?.userCountryCallingCode}${props?.data?.userPhoneNumber}`,
        },
      });
    } catch (error) {
      console.log(error);
    }
  }

  function openRazorPay(options) {
    setShowPaymentLoader(false);
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  async function razorpayPaymentFormButtonClick(
    key,
    price,
    orderId,
    userName,
    userEmail,
    userContact,
    gfg_order_id
  ) {
    var options = {
      key: key,
      amount: price,
      name: "GeeksforGeeks",
      description: title,
      order_id: orderId,
      utoken: "",
      handler: async function (response) {
        setShowVerificationLoader(true);
        const data = {
          gateway: "razorpay",
          razorpay_signature: response.razorpay_signature,
          gateway_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          page_url: window.location.href,
        };
        await axios
          .post(`payment/verify-payment/`, data)
          .then((res) => {
            if (res.data.status === "SUCCESS") {
              setPaymentConfirmTitle("Payment Successfull!!");
              setMessage("Enrollment Confirmed.");
              setExtra(" Click on the button to redirect to the batch page");
              setRedirectURL(res.data.redirect_url);
              setSuccessFlag(true);
              setButtonText("View Batch");
              successfullPurchaseEvent();
            } else {
              setPaymentConfirmTitle("Payment Un-successfull!!");
              setMessage("Your payment could not be processed.");
              setExtra(
                "Please try after some time. If your account was debited, the amount will be refunded within a week."
              );
              setSuccessFlag(false);
            }
            setIsPaymentDone(true);
          })
          .catch((error) => {
            setPaymentConfirmTitle("Payment Un-successfull!!");
            setMessage("Your payment could not be processed.");
            setExtra(
              "Please try after some time. If your account was debited, the amount will be refunded within a week."
            );
            setSuccessFlag(false);
            setIsPaymentDone(true);
          });
        setShowVerificationLoader(false);
      },
      modal: {
        ondismiss: () => {
          setShowQrSection(true);
          scrollToQrCard();
        },
      },
      prefill: {
        name: userName,
        email: userEmail,
        contact: userContact,
      },
      notes: {
        goi: gfg_order_id,
      },
      config: {
        display: {
          sequence: ["wallet", "netbanking", "upi", "paylater", "cardless_emi"],
        },
      },
    };
    if (window?.Razorpay) {
      openRazorPay(options);
    } else {
      window.razorPayInterval = setInterval(() => {
        if (window?.Razorpay) {
          clearInterval(window.razorPayInterval);
          openRazorPay(options);
        }
      }, 500);
    }
  }

  function openPhonePeDashboard(url) {
    // Create a temporary <a> element
    const link = document.createElement("a");
    link.href = url;
    link.rel = "noopener noreferrer";

    // Append the <a> element to the document body and click it
    document.body.appendChild(link);
    link.click();
  }

  async function paypalPaymentFormButtonClick() {
    var res = await loadScript(
      `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=USD`
    );

    if (!res) {
      const msg = "Failed to load Paypal SDK. Are you online?";
      alert(msg);
      createAndSendErrorObject(msg);
      return;
    }

    var data = {
      pageUrl: "https://www.geeksforgeeks.org" + window.location.pathname,
      transaction_token: transactionToken,
      gateway: "paypal",
      httpReferrer: document.referrer,
    };

    if (isCouponApplied) data["coupon_code"] = appliedCouponCode;

    data = JSON.stringify(data);

    var options;

    if (process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT") {
      options = {
        method: "post",
        mode: "cors",
        headers: {
          Authorization: AUTH_TOKEN,
          "Content-Type": "application/json",
        },
        body: data,
      };
    } else {
      options = {
        method: "post",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: data,
      };
    }
    setIsOpenPaypal(true);
    window.paypal
      .Buttons({
        createOrder: function () {
          return fetch(`${BACKEND_URL}payment/create-order/`, options)
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (data.status === "error") {
                setPaymentConfirmTitle("Payment Un-successfull!!");
                setMessage("Your payment could not be processed.");
                setExtra(
                  "Please try after some time. If your account was debited, the amount will be refunded within a week."
                );
                setSuccessFlag(false);
                setIsPaymentDone(true);
              } else {
                if (data.message.hasOwnProperty("refresh")) {
                  toastRef.current.click();
                  setTimeout(function () {
                    window.location.reload();
                  }, 5000);
                } else return data.message.order_id;
              }
            })
            .catch((err) => {
              if (androidPaymentQRLink) {
                setShowPaymentFailureModal(true);
              } else {
                sendRequestToLogging(
                  JSON.stringify({
                    traceback:
                      "error = " +
                      err +
                      " \n URL = " +
                      window.location.href +
                      "\ntraceback: \n" +
                      err.stack,
                  })
                );
                alert(ERROR_MESSAGE);
              }
            });
        },
        onApprove: function (response) {
          const data = {
            gateway: gateway,
            gateway_order_id: response.orderID,
            page_url: window.location.href,
          };
          axios
            .post(`/payment/verify-payment/`, data)
            .then((res) => {
              setPaymentConfirmTitle("Payment Successfull!!");
              setMessage("Enrollment Confirmed.");
              setExtra(" Click on the button to redirect to the batch page");
              setRedirectURL(res.data.redirect_url);
              setSuccessFlag(true);
              setButtonText("View Batch");
              setIsPaymentDone(true);
              successfullPurchaseEvent();
            })
            .catch((error) => {
              setPaymentConfirmTitle("Payment Un-successfull!!");
              setMessage("Your payment could not be processed.");
              setExtra(
                "Please try after some time. If your account was debited, the amount will be refunded within a week."
              );
              setSuccessFlag(false);
              setIsPaymentDone(true);
            });
        },
        onCancel: function (data) {
          setPaymentConfirmTitle("Payment Un-successfull!!");
          setMessage("Your payment could not be processed.");
          setExtra(
            "We'll re-verify your payment and update the status soon. Please try after some time. If your account was debited, the amount will be refunded within a week."
          );
          setSuccessFlag(false);
          setIsPaymentDone(true);
        },
        onError: (err) => {
          setPaymentConfirmTitle("Payment Un-successfull!!");
          setMessage("Your payment could not be processed.");
          setExtra(
            "Please try after some time. If your account was debited, the amount will be refunded within a week."
          );
          setSuccessFlag(false);
          setIsPaymentDone(true);
        },
      })
      .render("#paypal-button-container");
  }

  async function handlePayment() {
    setIsPaymentConfirmButtonClicked(true);
    var data = {
      transaction_token: transactionToken,
      gateway: gateway,
      pageUrl:
        process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT"
          ? window.location.href
          : "https://www.geeksforgeeks.org" + window.location.pathname,
      httpReferrer: document.referrer,
    };
    if (isCouponApplied) data["coupon_code"] = appliedCouponCode;

    if (["phone_pe", "razorpay"].includes(gateway)) {
      setShowPaymentLoader(true);
      await axios
        .post(`/payment/create-order/`, data)
        .then((res) => {
          if (res.data.message.hasOwnProperty("refresh")) {
            setShowPaymentLoader(false);
            toastRef.current.click();
            setTimeout(function () {
              window.location.reload();
            }, 3000);
          } else {
            if (gateway === "phone_pe")
              openPhonePeDashboard(res.data.message.payment_url);
            else {
              var price = res.data.message.amount * 100;
              var key = res.data.message.key;
              var orderId = res.data.message.order_id;
              var name = res.data.message.uname;
              var email = res.data.message.uemail;
              var phoneNumber = res.data.message.contact;
              var gfg_order_id = res.data.message.gfg_order_id;
              razorpayPaymentFormButtonClick(
                key,
                price,
                orderId,
                name,
                email,
                phoneNumber,
                gfg_order_id
              );
            }
          }
        })
        .catch((err) => {
          setShowPaymentLoader(false);
          if (androidPaymentQRLink) {
            setShowPaymentFailureModal(true);
          } else {
            sendRequestToLogging(
              JSON.stringify({
                traceback:
                  "error = " +
                  err +
                  " \n URL = " +
                  window.location.href +
                  "\ntraceback: \n" +
                  err.stack,
              })
            );
            alert(`${ERROR_MESSAGE} Please try again.`);
          }
        });
    } else {
      paypalPaymentFormButtonClick();
    }
    setIsPaymentConfirmButtonClicked(false);
  }

  async function addRemoveAddOns(addOnDetails) {
    if (addOnDetails?.type === ADDONS_TYPES.DOUBT_SUPPORT)
      props.toggleDoubtSupportButton();
    if (addOnDetails?.type === ADDONS_TYPES.EXTERNAL_CERTIFICATION)
      setIsIbmAddOnButtonLoading(true);
    if (
      (!props.isDoubtSupportAdded &&
        addOnDetails?.action === ADDONS_ACTIONS.ADD_TO_CART) ||
      addOnDetails?.action === ADDONS_ACTIONS.ADD_TO_CART
    ) {
      await axios
        .post("/payment/addtocart/", {
          type: addOnDetails?.type,
          transaction_token: transactionToken,
          course_id: courseId,
        })
        .then((res) => {
          setCouponDiscount(res.data.coupon_discount);
          setFinalPrice(res.data.payable_amount);
          setCoursePrice(res.data.product_price);
          if (addOnDetails?.type === ADDONS_TYPES.DOUBT_SUPPORT)
            props.toggleDoubtSupport(true);
          if (addOnDetails?.type === ADDONS_TYPES.EXTERNAL_CERTIFICATION)
            setIsIbmAddOnAdded(true);
        })
        .catch((err) => {
          if (androidPaymentQRLink) {
            setShowPaymentFailureModal(true);
          } else {
            sendRequestToLogging(
              JSON.stringify({
                traceback:
                  "error = " +
                  err +
                  " \n URL = " +
                  window.location.href +
                  "\ntraceback: \n" +
                  err.stack,
              })
            );
            alert(ERROR_MESSAGE);
          }
        });
    } else {
      await axios
        .post("/payment/addtocart/remove/", {
          type: addOnDetails?.type,
          transaction_token: transactionToken,
          course_id: courseId,
        })
        .then((res) => {
          setCouponDiscount(res.data.coupon_discount);
          setFinalPrice(res.data.payable_amount);
          setCoursePrice(res.data.product_price);
          if (addOnDetails?.type === ADDONS_TYPES.DOUBT_SUPPORT)
            props.toggleDoubtSupport(false);
          if (addOnDetails?.type === ADDONS_TYPES.EXTERNAL_CERTIFICATION)
            setIsIbmAddOnAdded(false);
        })
        .catch((err) => {
          sendRequestToLogging(
            JSON.stringify({
              traceback:
                "error = " +
                err +
                " \n URL = " +
                window.location.href +
                "\ntraceback: \n" +
                err.stack,
            })
          );
          alert(ERROR_MESSAGE);
        });
    }
    if (addOnDetails?.type === ADDONS_TYPES.DOUBT_SUPPORT)
      props.toggleDoubtSupportButton();
    if (addOnDetails?.type === ADDONS_TYPES.EXTERNAL_CERTIFICATION)
      setIsIbmAddOnButtonLoading(false);
  }

  function doubtSupportSection() {
    if (!props.data.has_doubt_assistance && addOnServices === undefined)
      return <div />;
    let addDsToCart = (
      <div
        className="card removeCardSpace pb-2 pt-2 orderSummaryCard"
        id="doubtSupport"
      >
        <div className="row mt-3 ml-2 mr-2">
          <div className="col-1 pr-0 pl-0 d-none d-sm-block alignDoubtSupportImage">
            <img
              className="img-fluid float-right"
              src="https://media.geeksforgeeks.org/img-practice/speech-bubble-1619078373.png"
              alt="speech_bubble_icon"
            />
          </div>
          <div className="col-12 col-sm-11 pl-2">
            <div className="row">
              <div className="col-9">
                <p className="text-left font-weight-bold mb-0 rightSectionheading">
                  Doubt Assistance
                </p>
              </div>
              <div className="col-3">
                {isLoaded ? (
                  <h6 className="font-weight-bold text-right sofia-pro">
                    {props.data.currency} {doubtSupportPrice}
                  </h6>
                ) : (
                  LineSkeleton(1)
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-8">
                <p className="text-left pl-0 mb-1 rightSectionDesc">
                  Get Doubt Assistance for: {props.data.courseName}
                </p>
                <p className="text-left pl-0 mb-0 rightSectionDesc">
                  Validity:{" "}
                  <span className="font-weight-bold">
                    {props.data.doubt_support_expiry_date} Months
                  </span>
                </p>
                <p className="text-left pl-0 mb-0 rightSectionDesc mt-1">
                  Get All Your Essential Technical Queries Resolved in an
                  Instant with GFG's Top Experts Available 24x7 !
                </p>
              </div>
              <div className="col-4 my-auto pl-0">
                <button
                  onClick={() => {
                    addRemoveAddOns({
                      type: ADDONS_TYPES.DOUBT_SUPPORT,
                      action: ADDONS_ACTIONS.ADD_TO_CART,
                    });
                  }}
                  ref={props.addToCartRef}
                  disabled={props.isDoubtSupportButtonClicked || !isLoaded}
                  className="btn btn-sm btn-success sofia-pro float-right"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    let dsAdded = (
      <div className="card removeCardSpace orderSummaryCard">
        <div className="row">
          <div className="col-3 col-lg-3 alignSummaryImage pl-4">
            <img
              className="img-fluid"
              src="https://media.geeksforgeeks.org/img-practice/_DoubtSupportAssistance-1677234418.png"
              alt="doubt_assistance_icon"
            />
          </div>
          <div className="col-9 col-lg-9 alignSummaryContent">
            <div className="card-body pb-0 mb-0">
              <div className="row pb-0">
                <div className="col-8">
                  <h6 className="font-weight-bold text-left rightSectionheading mb-0">
                    Doubt Support & Assistance
                  </h6>
                  <p className="d-sm-block text-left mb-0 rightSectionDesc">
                    Service Valid Upto :{" "}
                    <strong>
                      {props.data.doubt_support_expiry_date} Months
                    </strong>
                  </p>
                </div>
                <div className="col-4">
                  <h6 className="text-right">
                    {doubtSupportPrice !== 0 ? (
                      <span>
                        {props.data.currency} {doubtSupportPrice}
                      </span>
                    ) : (
                      <span style={{ display: "inline-block" }}>
                        <s className="doubtSupportPriceStriked">
                          {props.data.currency}{" "}
                          {props.data.currency === "₹" ? " 1500 " : " 19.99 "}
                        </s>
                        <span className="freeChip">FREE</span>
                      </span>
                    )}
                  </h6>
                  {doubtSupportPrice !== 0 && (
                    <small
                      onClick={() => {
                        addRemoveAddOns({
                          type: ADDONS_TYPES.DOUBT_SUPPORT,
                          action: ADDONS_ACTIONS.REMOVE_FROM_CART,
                        });
                      }}
                      ref={props.addToCartRef}
                      type="button"
                      disabled={props.isDoubtSupportButtonClicked}
                      className="text-danger float-right pl-0 pt-0 d-none d-sm-block"
                    >
                      REMOVE
                    </small>
                  )}
                </div>
              </div>
              <div className="row mb-0 mt-2">
                {/* <p className = "col-12 text-left pr-0 rightSectionDesc mb-0">Valid for : <span className = "font-weight-bold">{props.data.courseName}</span></p> */}
                {/* <p className = "col-12 text-left rightSectionDesc mb-1">Valid Upto : <span className = "font-weight-bold">{props.data.doubt_support_expiry_date} Months</span></p> */}
                <p className="col-12 text-left rightSectionDesc mb-1">
                  Get All Your Essential Technical Queries Resolved in an
                  Instant with GFG's Top Experts Available 24x7 !
                </p>
              </div>
              <div className="row d-block d-sm-none">
                <div className="col-12">
                  {doubtSupportPrice !== 0 && (
                    <button
                      onClick={() => {
                        addRemoveAddOns({
                          type: ADDONS_TYPES.DOUBT_SUPPORT,
                          action: ADDONS_ACTIONS.REMOVE_FROM_CART,
                        });
                      }}
                      disabled={props.isDoubtSupportButtonClicked}
                      className="btn btn-sm w-100 btn-outline-danger"
                    >
                      REMOVE
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    let dsAddOn = (addOnValidity = props.data.doubt_support_expiry_date) => {
      return (
        <div className="card removeCardSpace orderSummaryCard">
          <div className="row">
            <div className="col-3 col-lg-3 alignSummaryImage pl-4">
              <img
                className="img-fluid"
                src="https://media.geeksforgeeks.org/img-practice/_DoubtSupportAssistance-1677234418.png"
                alt="doubt_assistance_icon"
              />
            </div>
            <div className="col-9 col-lg-9 alignSummaryContent">
              <div className="card-body pb-0 mb-0">
                <div className="row pb-0">
                  <div className="col-12 mb-2">
                    <OnOfferLabel />
                  </div>
                  <div className="col-8">
                    <h6 className="font-weight-bold text-left rightSectionheading mb-0">
                      Doubt Support & Assistance
                    </h6>
                    <p className="d-sm-block text-left mb-0 rightSectionDesc">
                      Service Valid Upto :{" "}
                      <strong>
                        {addOnValidity ?? props.data.doubt_support_expiry_date}{" "}
                        Months
                      </strong>
                    </p>
                  </div>
                  <div className="col-4">
                    <h6 className="text-right">
                      <span style={{ display: "inline-block" }}>
                        <s className="doubtSupportPriceStriked">
                          {props.data.currency}{" "}
                          {props.data.currency === "₹" ? " 1500 " : " 19.99 "}
                        </s>
                        <span className="freeChip">FREE</span>
                      </span>
                    </h6>
                  </div>
                </div>
                <div className="row mb-0 mt-2">
                  {/* <p className = "col-12 text-left pr-0 rightSectionDesc mb-0">Valid for : <span className = "font-weight-bold">{props.data.courseName}</span></p> */}
                  {/* <p className = "col-12 text-left rightSectionDesc mb-1">Valid Upto : <span className = "font-weight-bold">{props.data.doubt_support_expiry_date} Months</span></p> */}
                  <p className="col-12 text-left rightSectionDesc mb-1">
                    Get All Your Essential Technical Queries Resolved in an
                    Instant with GFG's Top Experts Available 24x7 !
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
    if (addOnServices !== undefined) {
      let addOnHasDs = addOnhasDsHelper();
      if (addOnHasDs !== -1) {
        return dsAddOn(
          addOnServices[addOnHasDs]?.service_info?.validity ||
            props.data.doubt_support_expiry_date
        );
      }
      if (!props.data.has_doubt_assistance) return <div />;
      if (!props.isDoubtSupportAdded) {
        return addDsToCart;
      } else {
        return dsAdded;
      }
    }
  }

  const youSavePrice = () => {
    const val =
      Number(coursePromotionalPrice - coursePrice) +
      Number(premiumDiscount || 0) +
      Number(couponDiscount || 0) +
      Number(addOnSavings || 0);
    return Math.round(val * 100) / 100;
  };

  const OnOfferLabel = () => {
    return <span className="offerChip">On Offer</span>;
  };

  const randomProfileImages = useMemo(() => {
    if (!profileImages || profileImages.length <= 4) return profileImages;
    const shuffled = [...profileImages].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  }, [profileImages]);

  //   const CountdownTimer = () => {
  //   const [timeRemaining, setTimeRemaining] = useState("");

  //   const calculateTimeRemaining = () => {
  //     const now = new Date();
  //     const nextMidnight = new Date(now);
  //     nextMidnight.setHours(24, 0, 0, 0);

  //     const diffInMs = nextMidnight - now; // Time difference in milliseconds
  //     const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  //     const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  //     const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

  //     return `${hours}hrs : ${minutes}mins : ${seconds}sec`;
  //   };

  //   useEffect(() => {
  //     const interval = setInterval(() => {
  //       setTimeRemaining(calculateTimeRemaining());
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   }, []);

  //   return (
  //     <div>
  //       <p>{timeRemaining}</p>
  //     </div>
  //   );
  // };

  if (isPaymentDone) {
    return (
      <ModalViewComponent
        title={paymentConfirmtitle}
        message={message}
        extra={extra}
        redirect_url={redirectURL}
        success_flag={successFlag}
        button_text={buttonText}
        failure_redirect_url={redirectURLForFailure}
      />
    );
  } else if (isOpenPaypal)
    return (
      <div className="mt-5">
        <div id="gfg_payment_confirm"></div>
        <div id="paypal-button-container">
          {/* <PaypalPayments transaction_token = {transactionToken}/> */}
        </div>
      </div>
    );
  else {
    return (
      <section id="orderSummary">
        {showVerificationLoader && <Loader />}

        <PhonePePaymentComponent />

        <div
          class="modal fade"
          id="discountModal"
          tabindex="-1"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div>
                  <p className="heading sofia-pro">
                    Exclusively for Our Favourite Geek !
                  </p>
                  <p className="discountPercent sofia-pro">
                    {Math.floor(
                      ((coursePromotionalPrice - coursePrice) /
                        coursePromotionalPrice) *
                        100
                    )}
                    % OFF
                  </p>
                  <p
                    className="sofia-pro warning mt-2"
                    style={{ color: "red" }}
                  >
                    Don't Miss On this Special Discount.
                    <br />
                    Offer Expires Soon!
                  </p>
                  <button
                    type="button"
                    className="btn btn-success sofia-pro closeDiscountModal"
                    data-dismiss="modal"
                  >
                    Okay
                  </button>
                  <p className="sofia-pro discountText">
                    <Icon name="info circle" /> Discount Applied
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="gfg_payment_confirm"></div>

        <div className="row">
          <div className="col-lg-8">
            {props?.isThreeNinetyActive ? (
              <div className="Three90PromotionBanner">
                <div className="profileImagesContainer">
                  {randomProfileImages?.map((src, index) => (
                    <div key={index} className="profileImageWrapper">
                      <Image src={src} avatar />
                    </div>
                  ))}
                  <span className="profileCircle">+9</span>
                </div>
                <div className="textThree90">
                  users started the Three 90 challenge in the last 10 minutes.
                  Don’t get left behind!
                </div>
              </div>
            ) : null}
            {/* {!props?.isPremiumUser && props?.isShowPremiumUpgradeBanner && (
              <div className="d-flex align-items-center justify-content-between premiumRedirectionNudge">
                <p>
                  Unlock Premium to access additional courses and exclusive
                  benefits!
                </p>
                <a href={PREMIUM_PAGE_URL} target="_blank" rel="noreferrer">
                  Explore
                </a>
              </div>
            )} */}
            <div className="row orderSummaryHeading">
              <h5 className="col-md-6 font-weight-bold text-left sofia-pro">
                Order Summary
              </h5>
            </div>
            <div className="card removeCardSpace orderSummaryCard">
              <div className="row">
                <div className="col-3 col-lg-3 alignSummaryImage pl-4">
                  <img
                    alt=""
                    className="img-fluid rounded"
                    src={props.data.paymentCheckoutImage}
                  />
                </div>
                <div className="col-9 col-lg-9 alignSummaryContent">
                  <div className="card-body pb-0">
                    <div className="row">
                      <div className="col-8 pr-0">
                        <h6 className="font-weight-bold text-left rightSectionheading">
                          {BATCH_SLUG_COURSE_NAME_MAPPING?.[
                            props?.data?.batchSlug
                          ] || props.data.courseName}
                        </h6>
                        <div className="row">
                          {props.data.course_type === 2 &&
                          props.data.courseDuration ? (
                            <div className="col-12 pr-0">
                              <p className="text-left d-none d-sm-block alignBatchName rightSectionDesc">
                                Course Duration:{" "}
                                <span className="font-weight-bold">
                                  {props.data.courseDuration}
                                </span>
                              </p>
                              <p className="text-left d-block d-sm-none alignBatchNameSmall rightSectionDesc">
                                Course Duration:{" "}
                                <span className="font-weight-bold">
                                  {props.data.courseDuration}
                                </span>
                              </p>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-4 pl-0">
                        <h6 className="text-muted d-none d-sm-block text-right mb-0">
                          Price
                        </h6>
                        <p className="text-muted1 d-block d-sm-none text-right mb-0">
                          Price
                        </p>
                        {isLoaded ? (
                          <>
                            {coursePromotionalPrice && (
                              <h6 className="text-right mb-0">
                                <s>
                                  {props.data.currency} {coursePromotionalPrice}
                                </s>
                              </h6>
                            )}
                            <h6 className="text-right font-weight-bold">
                              {props.data.currency} {coursePrice}
                            </h6>
                          </>
                        ) : (
                          <h6 className="text-right">{LineSkeletonLg()}</h6>
                        )}
                      </div>
                    </div>
                    {props.data.warningMessage &&
                      props.data.warningMessage.length > 0 && (
                        <div
                          className={`d-flex align-items-center ${
                            addOnServices?.find(
                              (obj) =>
                                obj?.service_info?.service_type ===
                                "instant discount"
                            )
                              ? ""
                              : "pb-2"
                          }`}
                        >
                          <img
                            className="img-fluid info-image pt-2"
                            src="https://media.geeksforgeeks.org/img-practice/Group5631-1621599978.png"
                            alt="info_icon"
                          />
                          <div className="urw-din batchCoupon text-dark ml-2 text-left">
                            {props.data.warningMessage}
                          </div>
                        </div>
                      )}
                    {(function () {
                      const addOnDiscountObj = (addOnServices || []).find(
                        (obj) =>
                          obj?.service_info?.service_type === "instant discount"
                      );

                      if (addOnDiscountObj) {
                        return (
                          <div
                            className={`text-left addOnDiscountSection ${
                              props?.data?.warningMessage &&
                              props.data.warningMessage?.length > 0
                                ? ""
                                : "pt-4"
                            }`}
                          >
                            <span>
                              <img
                                className="img-fluid addOnDiscountIcon info-image"
                                src="https://media.geeksforgeeks.org/img-practice/discount_percent_icon-1678693205.svg"
                                alt="dicount_percentage_icon"
                              />
                            </span>
                            <span className="addOnDiscountText ml-2">{`Extra ${addOnDiscountObj?.service_info?.description} off Applied`}</span>
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 mb-4">
              {addOnServices?.length > 0 ? (
                <div className="addOns_header">
                  <h5 className="font-weight-bold text-left mb-2 sofia-pro">
                    Grab These Add-Ons Now!
                  </h5>
                  {currentTime && !SALE_ACTIVE && (
                    <AddOnTimer
                      services={addOnServices}
                      currentTime={currentTime}
                      setAddOnSavings={setAddOnSavings}
                    />
                  )}
                </div>
              ) : null}

              {props?.data?.hasIbmCertification ? (
                <IbmAddOnService
                  ibmContentDetails={props?.data?.ibmCertificationDetails}
                  isIbmAddOnAdded={isIbmAddOnAdded}
                  addRemoveAddOns={addRemoveAddOns}
                  isIbmAddOnButtonLoading={isIbmAddOnButtonLoading}
                  courseSlug={props?.courseSlug}
                />
              ) : null}
              {doubtSupportSection()}

              {showPaymentFailureModal ? (
                <PaymentsFailureModal
                  setShowPaymentFailureModal={setShowPaymentFailureModal}
                  androidPaymentQRLink={androidPaymentQRLink}
                />
              ) : (
                ""
              )}
              {addOnServices?.length > 0 && currentTime && (
                <AddOnServices
                  services={addOnServices}
                  currentTime={currentTime}
                  OnOfferLabel={OnOfferLabel}
                  setAddOnSavings={setAddOnSavings}
                  defaultAddOnThumbnail={props?.data?.addOnsDefaultThumbnail}
                />
              )}
              {props.showPlacementAssistanceBanner === 1 && (
                <div className="card removeCardSpace orderSummaryCard">
                  <div className="row">
                    <div className="col-3 col-lg-3 alignSummaryImage pl-4">
                      <img
                        className="img-fluid"
                        src="https://media.geeksforgeeks.org/img-practice/placementCardIcon-1656580940.png"
                        alt="briefcase"
                      />
                    </div>
                    <div className="col-9 col-lg-9 alignSummaryContent">
                      <div className="card-body pb-0 mb-0">
                        <div className="row pb-0">
                          <div className="col-8">
                            <h6 className="font-weight-bold text-left rightSectionheading mb-0">
                              Placement Assistance Service
                            </h6>
                            <p className="d-sm-block text-left mb-0 rightSectionDesc">
                              Service
                            </p>
                          </div>
                          <div className="col-4">
                            <h6 className="text-right sofia-pro">
                              <span style={{ display: "inline-block" }}>
                                <s>
                                  {props.data.currency}{" "}
                                  {props.data.currency === "₹"
                                    ? " 5000"
                                    : " 69.99"}
                                </s>
                                <span className="freeChip">FREE</span>
                              </span>
                            </h6>
                          </div>
                          <p className="col-12 text-left rightSectionDesc mb-1">
                            Resume Reviews, Personalized Referrals in Top
                            Companies, Unmatched Placement Guidance and Much
                            More !!!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-4 customFloaterSpacing">
            <div className="card removeCardSpace paymentDetailsCard">
              {/* remove margin top if offer label is not shown */}
              {/* <div
              <div className="card-body mt-2">
                {/* <div
                className={`card-body ${
                  props.isThreeNinetyExempted ? "" : "mt-2"
                }`}
              > */}
              <div className="card-body">
                {!isLoaded ? (
                  LineSkeleton(10)
                ) : (
                  <>
                    {props?.promotionalUpcomingEvents?.payments_amount_card_pill && props?.data?.courseFeeType === 1 ? (
                      <OfferLabel
                        classes="for_payment_details_card"
                        text={props?.promotionalUpcomingEvents?.payments_amount_card_pill?.[0]?.title}
                      />
                    ) : null}
                    <p className="text-muted text-left mb-1 discount-styles">
                      Course Price{" "}
                      <span className="float-right">
                        {props.data.currency} {coursePromotionalPrice}
                      </span>
                    </p>
                    {Number(coursePromotionalPrice - coursePrice) > 0 && (
                      <p className="text-muted text-left mb-1 discount-styles">
                        <span style={{ display: "inline-block" }}>
                          Discount{" "}
                          <span
                            style={{
                              fontSize: "12px",
                              color: "red",
                              display: "block",
                            }}
                          >
                            (Exclusive Offer)
                          </span>
                        </span>{" "}
                        <span
                          className="float-right"
                          style={{ color: "green" }}
                        >
                          - {props.data.currency}{" "}
                          {Math.round(
                            Number(coursePromotionalPrice - coursePrice) * 100
                          ) / 100}
                        </span>
                      </p>
                    )}
                    {premiumDiscount !== 0 && (
                      <p className="text-muted text-left mb-1 discount-styles">
                        Premium Discount{" "}
                        <span className="float-right">
                          {props.data.currency} {premiumDiscount}
                        </span>
                      </p>
                    )}
                    {props?.courseSlug &&
                    !couponNotApplicableCourses.includes(
                      props.courseSlug.toLowerCase()
                    ) &&
                    couponDiscount !== 0 ? (
                      <p className="text-muted text-left discount-styles mb-1">
                        Coupon Discount{" "}
                        <span
                          className="float-right"
                          style={{ color: "green" }}
                        >
                          - {props.data.currency} {couponDiscount}
                        </span>
                      </p>
                    ) : null}
                    {props.isDoubtSupportAdded &&
                      doubtSupportPrice !== 0 &&
                      addOnhasDsHelper() === -1 && (
                        <p className="text-muted text-left discount-styles mb-0">
                          Doubt Support{" "}
                          <span className="float-right">
                            <span>
                              {props.data.currency} {doubtSupportPrice}
                            </span>{" "}
                          </span>
                        </p>
                      )}
                    {addOnSavings > 0 && (
                      <p className="text-muted text-left mb-1 discount-styles">
                        <span style={{ display: "inline-block" }}>
                          Additional Services
                          <span
                            style={{
                              fontSize: "12px",
                              color: "red",
                              display: "block",
                            }}
                          >
                            (Discount Applied)
                          </span>
                        </span>
                        <span
                          style={{
                            display: "inline-block",
                            textAlign: "end",
                          }}
                          className="float-right"
                        >
                          {props.data.currency}{" "}
                          {Math.round(Number(addOnSavings) * 100) / 100}
                          <span style={{ color: "green", display: "block" }}>
                            - {props.data.currency}{" "}
                            {Math.round(Number(addOnSavings) * 100) / 100}
                          </span>
                        </span>
                      </p>
                    )}
                    <div className="mt-2">
                      <hr />
                      <strong>
                        <p className="text-left total-amount-styles discount-styles">
                          You Pay :{" "}
                          <span className="font-weight-bold float-right">
                            {props.data.currency} {finalPrice}
                          </span>
                        </p>
                      </strong>
                    </div>
                    {!showCouponIp &&
                    !couponNotApplicableCourses.includes(
                      props.courseSlug.toLowerCase()
                    ) ? (
                      <p className="text-left showCouponIp mt-1">
                        <span
                          onClick={() => {
                            setShowCouponIp(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} /> Have a
                          coupon?
                        </span>
                      </p>
                    ) : null}

                    {props?.courseSlug &&
                    !couponNotApplicableCourses.includes(
                      props.courseSlug.toLowerCase()
                    ) ? (
                      <div
                        style={
                          showCouponIp
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        <div className="input-group input-group-sm mt-3 mb-3">
                          <input
                            type="text"
                            onChange={(e) =>
                              setCouponCode(e.target.value.toUpperCase())
                            }
                            value={couponCode}
                            className="form-control"
                            placeholder="Enter Coupon Code"
                            aria-describedby="coupon-apply"
                          />
                          <div className="input-group-append">
                            <button
                              onClick={() => {
                                handleCouponApply();
                              }}
                              disabled={
                                isCouponButtonPressed || isCouponApplied
                              }
                              className="btn btn-dark sofia-pro mt-0"
                              id="coupon-apply"
                            >
                              Apply
                            </button>
                          </div>
                        </div>

                        {couponError && (
                          <div className="row mt-0 pt-0">
                            <small className="text-danger col-12 text-left">
                              {couponErrorMessage}
                            </small>
                          </div>
                        )}

                        {isCouponApplied && (
                          <div className="row mt-0 pt-0">
                            <small className="text-success col-7 pr-0 text-left">
                              Coupon Applied !!
                            </small>
                            <small
                              type="button"
                              onClick={() => {
                                handleCouponRemove();
                              }}
                              className="text-danger col-5 text-right"
                            >
                              REMOVE
                            </small>
                          </div>
                        )}
                      </div>
                    ) : null}
                    <hr />

                    <div className="mt-2">
                      {youSavePrice() > 0 && (
                        <div className="youSaveInfo sofia-pro mb-2">
                          <span>
                            <img
                              src="https://media.geeksforgeeks.org/img-practice/get-money-1673940341.png"
                              alt="coin_icon"
                            />{" "}
                            You Save :- {props.data.currency} {youSavePrice()}
                          </span>
                        </div>
                      )}
                      <Button
                        onClick={() => {
                          handlePayment();
                        }}
                        disabled={
                          isPaymentConfirmButtonClicked || showPaymentLoader
                        }
                        loading={showPaymentLoader}
                        size="large"
                        className="payNowBtn mt-1 mb-1"
                      >
                        <Shimmer />
                        {"Pay Now"}
                        {/* {props?.isThreeNinetyActive
                          ? "Get 90% Refund"
                          : "Pay Now"} */}
                        {/* {props.isThreeNinetyExempted
                          ? "Pay Now"
                          : "Avail Refund"} */}
                      </Button>
                      {/* <p className="moneyBackMsg mt-2 mb-0">
                                            <Icon name="info circle" /> 7 Days Money Back Guarantee
                                        </p> */}
                      <p class="mt-3" style={{ fontSize: "12px" }}>
                        <Icon name="info circle" />{" "}
                        <a
                          target="_blank"
                          rel="noopener"
                          href="/terms-of-service"
                          style={{ color: "black" }}
                        >
                          Terms & Conditions
                        </a>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>

            {showQrSection && (
              <div className="card removeCardSpace mt-4 appDownloadQr">
                <div className="card-body ">
                  <p>Facing issue with payment?</p>
                  <img
                    src="https://www.geeksforgeeks.org/_next/image?url=https%3A%2F%2Fmedia.geeksforgeeks.org%2Fimg-practice%2Fprod%2Fgeneric%2F1%2FWeb%2FOther%2FGroup%252039228_1713251477.png&w=256&q=75"
                    alt="qr_code"
                  />
                  <p>Scan QR to pay through App</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <button onClick={notify} ref={toastRef} className="invisible"></button>
      </section>
    );
  }
}

export default withRouter(OrderSummaryComponent);
